import APIConstant from 'constants/ApiConstant';
import { getRequest, postRequest } from 'utils/apiUtils';
import { getValidDataFromResponse } from 'utils/utilities';

const { makeAutoObservable, runInAction, values } = require('mobx');

class ToolBoxEducationStore {
	setLoaderForToolBox = false;
	isSubmitting = false;
	isToolboxLoading = false;

	toolBoxData = [];
	toolBoxEducationData = [];

	constructor() {
		makeAutoObservable(this);
	}

	getAllToolboxAndSubEducation = () => {
		return new Promise(async (resolve, reject) => {
			try {
				const { response } = await getRequest({ url: APIConstant.TOOLBOX_TYPES_WITH_SUB_EDUCATION });
				const { result, error } = getValidDataFromResponse({ response, isRequired: false });

				if (!error) {
					this.setToolBoxData(result);
					resolve();
				} else {
					throw new Error('Something went wrong');
				}

				// console.log('response', result, error);
			} catch (error) { }
		});
	};

	getToolboxEducation = ({ toolbox_id, sub_education_type_id, state_id, role_id }) => {
		return new Promise(async (resolve, reject) => {
			try {
				this.setIsToolboxLoading(true)
				this.setToolBoxEducationData([])
				const { response } = await getRequest({ url: `${APIConstant.GET_TOOLBOX_EDUCATION}/${toolbox_id}/${sub_education_type_id}/${state_id}/${role_id}` });
				const { result, error } = getValidDataFromResponse({ response, isRequired: false });

				if (!error) {
					this.setIsToolboxLoading();
					this.setToolBoxEducationData(result);
					resolve();
				} else {
					this.setIsToolboxLoading();
					throw new Error('Something went wrong');
				}

				// console.log('response', result, error);
			} catch (error) { }
		});
	};

	submitNewToolboxEducation = body => {
		return new Promise(async (resolve, reject) => {
			try {
				this.setIsSubmitting(true);
				const { response } = await postRequest({ url: APIConstant.INSERT_TOOLBOX_EDUCATION, payload: body });
				const { result, error } = getValidDataFromResponse({ response });

				if (!error) {
					this.setIsSubmitting();
					resolve();
				} else {
					throw new Error('Something went wrong');
				}
			} catch (error) {
				this.setIsSubmitting();
				reject();
			}
		});
	};

	setFetchingInitialToolboxData = (value = false) => {
		runInAction(() => {
			this.setLoaderForToolBox = value;
		});
	};

	setToolBoxData = (data = []) => {
		runInAction(() => {
			this.toolBoxData = data;
		});
	};

	setToolBoxEducationData = (data = []) => {
		runInAction(() => {
			this.toolBoxEducationData = data;
		});
	};

	setIsToolboxLoading = (value = false) => {
		runInAction(() => {
			this.isToolboxLoading = value
		})
	}

	setIsSubmitting = (value = false) => {
		runInAction(() => {
			this.isSubmitting = value;
		});
	};
}

export default ToolBoxEducationStore;
